'use strict';

function CustomerSubscriptions() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  /* Higher is better */
  this._subscriptionStatusPrecedence = {
    past_due: 7,
    active: 6,
    pending: 5,
    initialized: 4,
    canceled: 3,
    canceled_expired: 2,
    declined: 1
  };
  this._map = null;

  /*
    map: _SubscriptionsMap.js, plan names to model names
  */
  this.retrieveSubscriptions = function (map, callback) {
    this._map = map;
    if (this.presenter.hasAction('account.index_subscriptions')) {
      if (this.presenter.models.subscriptions) {
        if (this.presenter.models.subscriptions._initialized) {
          this.presenter.updateModel('subscriptions', null, this._onRetrieveSubscriptions.bind(this, { map: map, callback: callback }));
        } else {
          this._subscriptionCallbackId = this.presenter.addCallbackToAction('account.index_subscriptions', this._onRetrieveSubscriptionsActionCallback.bind(this, { map: map, callback: callback }));
        }
      } else {
        this.presenter.createModel('subscriptions', { action: 'account.index_subscriptions' }, this._onRetrieveSubscriptions.bind(this, { map: map, callback: callback }));
      }
    } else {
      callback(null);
    }
  };

  this.createSubscription = function (subscriptionName, paymentMethodId, planId, promoCodeId, callback) {
    if (this.presenter.hasAction('subscriptions.create_subscription')) {
      this.presenter.performAction('subscriptions.create_subscription', {
        payment_method_id: paymentMethodId,
        braintree_plan_id: planId,
        braintree_discount_id: promoCodeId
      }, this._onCreateSubscription.bind(this, subscriptionName, callback));
    }
  };

  this.createFreeSubscription = function (subscriptionName, callback) {
    if (this.presenter.hasAction('subscriptions.create_free_subscription')) {
      this.presenter.performAction('subscriptions.create_free_subscription', null, this._onCreateSubscription.bind(this, subscriptionName, callback));
    } else {
      console.error('create_free_subscription is required to perform the Create action.');
    }
  };

  this.updateSubscriptionPayment = function (subscriptionName, paymentMethodId, callback) {
    if (this.presenter.hasAction(subscriptionName + '.update_subscription')) {
      this.presenter.performAction(subscriptionName + '.update_subscription', {
        payment_method_id: paymentMethodId
      }, this._onUpdateSubscription.bind(this, subscriptionName, callback));
    }
  };

  this.cancelSubscription = function (subscriptionName, callback) {
    if (this.presenter.hasAction(subscriptionName + '.cancel_subscription')) {
      this.presenter.performAction(subscriptionName + '.cancel_subscription', null, this._onCancelSubscription.bind(this, subscriptionName, callback));
    } else {
      console.error('cancel_subscription is required to perform the Cancel action.');
    }
  };

  this._onRetrieveSubscriptionsActionCallback = function (args, data, response) {
    this.presenter.removeCallbackFromAction('account.index_subscriptions', this._subscriptionCallbackId);
    this._onRetrieveSubscriptions(args, data, response);
  };

  this._onRetrieveSubscriptions = function (args, data, response) {
    var map = args.map ? args.map : this._map;
    var callback = args.callback ? args.callback : function () {};

    if (response == null) response = 200; // Create model does not return response unless error
    if (this.isGeneralConnectionIssue(data, response)) {
      // Connection error
      callback(data, response);
    } else if (response === 200 && this.presenter.getModelProperty('subscriptions.subscriptions')) {
      // Filter: "active" subscriptions, canceled subscription if another subscription with same plan exists
      var subscriptions = this.presenter.getModelProperty('subscriptions.subscriptions');
      var activeSubscriptionsMap = {};
      var activeSubscriptions = [];
      var subscription = null;

      if (args.useSubscriptionPrecedenceMapping) {
        // review all subscriptions returned from BE
        // sort by type and precedence
        for (var i = 0; i < subscriptions.length; i++) {
          subscription = subscriptions[i];
          var currentPrecedence = this._determinePrecedence(subscription);
          var subscriptionName = args.subscriptionName ? args.subscriptionName : map[subscription.braintree_plan_id];
          var mapSubscription = activeSubscriptionsMap[subscriptionName];
          var mapPrecedence = 0;
          if (mapSubscription) mapPrecedence = this._determinePrecedence(mapSubscription);

          // Populate map if:
          if (
          // Nothing in map yet
          !mapSubscription ||
          /*
            // this subscription is active and next billing date is furtherest in the future than any encountered
            (subscription.next_billing_date &&
              activeSubscriptionsMap[subscription.braintree_plan_id].next_billing_date <
                subscription.next_billing_date) ||
            // haven't encountered an active subscription yet and this subscription is canceled with furthest future end date
            (!activeSubscriptionsMap[subscription.braintree_plan_id].next_billing_date &&
              activeSubscriptionsMap[subscription.braintree_plan_id].end_date &&
              subscription.end_date &&
              new Date(activeSubscriptionsMap[subscription.braintree_plan_id].end_date) <
                new Date(subscription.end_date)) ||
            // haven't encountered an active or canceled subscription yet and this subscription was created most recently
            (!activeSubscriptionsMap[subscription.braintree_plan_id].next_billing_date &&
              !activeSubscriptionsMap[subscription.braintree_plan_id].end_date &&
              new Date(activeSubscriptionsMap[subscription.braintree_plan_id].created_at) <
                new Date(subscription.created_at))
            */
          // Subscription in map has lower precedence than current iteration subscription
          mapPrecedence < currentPrecedence ||
          // Subscription in map has same precedence as the current iteration but current iteration was created more recently
          mapPrecedence == currentPrecedence && new Date(mapSubscription.created_at) < new Date(subscription.created_at)) {
            activeSubscriptionsMap[subscriptionName] = subscription;
          }
        }

        for (var key in activeSubscriptionsMap) {
          activeSubscriptions[activeSubscriptions.length] = activeSubscriptionsMap[key];
        }
      } else {
        // select only the most recently created subscription
        if (subscriptions.length > 0) {
          subscription = subscriptions[subscriptions.length - 1];
          activeSubscriptions[0] = subscription;
        }
      }

      // Create model for subscriptions and update
      if (activeSubscriptions.length > 0) {
        var deferredArray = [];
        for (var i = 0; i < activeSubscriptions.length; i++) {
          var subscriptionName = args.subscriptionName ? args.subscriptionName : map[subscription.braintree_plan_id];
          if (subscriptionName) {
            var def = $.Deferred();
            deferredArray.push(def);
            if (this.presenter.models[subscriptionName]) {
              this.presenter.updateModel(subscriptionName, activeSubscriptions[i]);
            } else {
              this.presenter.createModel(subscriptionName, {
                data: activeSubscriptions[i]
              });
            }

            this.presenter.updateModel(subscriptionName, null, this._onRetrieveActiveSubscriptions.bind(this, def));
          }
        }
        if (args.data) {
          data = args.data;
        }
        if (args.response) {
          response = args.response;
        }
        $.when.apply(null, deferredArray).done(callback.bind(null, data, response));
        $.when.apply(null, deferredArray).fail(callback.bind(null, data, response));
      } else {
        if (args.data) {
          data = args.data;
        }
        if (args.response) {
          response = args.response;
        }
        callback(data, response);
      }
    } else {
      // Unexpected error
      callback(data, response);
    }
  };

  this._onRetrieveActiveSubscriptions = function (deferred, data, response) {
    if (response === 200) {
      deferred.resolve();
    } else {
      deferred.reject();
    }
  };

  this._onCreateSubscription = function (subscriptionName, callback, data, response) {
    if (response === 200) {
      if (this.presenter.models[subscriptionName]) {
        delete this.presenter.models[subscriptionName];
      }
      this.presenter.createModel(subscriptionName, { data: data });
      this.presenter.updateModel('subscriptions', null, this._onRetrieveSubscriptions.bind(this, {
        subscriptionName: subscriptionName,
        callback: callback,
        data: data,
        response: response
      }));
      return;
    }
    if (callback) callback(data, response);
  };

  this._onUpdateSubscription = function (subscriptionName, callback, data, response) {
    if (response === 200) {
      this.presenter.updateModel(subscriptionName, data);
      this.presenter.updateModel('subscriptions', null, this._onRetrieveSubscriptions.bind(this, {
        subscriptionName: subscriptionName,
        callback: callback,
        data: data,
        response: response
      }));
      return;
    }
    if (callback) callback(data, response);
  };

  this._onCancelSubscription = function (subscriptionName, callback, data, response) {
    if (response === 200) {
      delete this.presenter.models[subscriptionName];
      this.presenter.updateModel('subscriptions', null, this._onRetrieveSubscriptions.bind(this, {
        subscriptionName: subscriptionName,
        callback: callback,
        data: data,
        response: response
      }));
      return;
    }
    if (callback) callback(data, response);
  };

  // subscription states
  this.hasNoSubscription = function (subscriptionName) {
    return typeof this.presenter.models[subscriptionName] === 'undefined';
  };

  this.hasCanceledSubscription = function (subscriptionName) {
    if (this.hasNoSubscription(subscriptionName)) return false;
    return this.presenter.models[subscriptionName].status === 'canceled';
  };

  // subscription properties
  this._getFormattedSubscriptionEndDate = function (subscriptionName) {
    var date = '';
    var subscription = this.presenter.models[subscriptionName];
    if (subscription && subscription.end_date) {
      date = moment(subscription.end_date).format('MMM D, YYYY');
    }
    return date;
  };

  this._getFormattedNextBillingDate = function (subscriptionName) {
    var date = '';
    var subscription = this.presenter.models[subscriptionName];
    if (subscription && subscription.next_billing_date) {
      date = moment(subscription.next_billing_date).format('MMM D, YYYY');
    }
    return date;
  };

  this._getFormattedSubscriptionStartDate = function (subscriptionName) {
    var date = '';
    var subscription = this.presenter.models[subscriptionName];
    if (subscription && subscription.created_at) {
      date = moment(subscription.created_at).format('MMM D, YYYY');
    }
    return date;
  };

  this._getNextBillingAmount = function (subscriptionName) {
    var amount = '0.00';
    var subscription = this.presenter.models[subscriptionName];
    if (subscription && subscription.price) {
      amount = subscription.price;
    }
    return amount;
  };

  this._getDiscountBillingAmount = function (subscriptionName) {
    var amount = '0.00';
    var subscription = this.presenter.models[subscriptionName];
    if (subscription && subscription.price) {
      amount = subscription.price - (subscription.discount_amount ? subscription.discount_amount : 0);
    }
    return amount;
  };

  this._getActivePaymentMethod = function (subscriptionName) {
    var paymentMethod = void 0;
    var subscription = this.presenter.models[subscriptionName];
    if (subscription && subscription.payment_method_id) {
      var paymentId = subscription.payment_method_id;
      var paymentMethods = this.presenter.models.payments;
      if (paymentMethods && paymentMethods._initialized && paymentMethods.payment_methods && paymentMethods.payment_methods.length) {
        for (var i = 0; i < paymentMethods.payment_methods.length; i++) {
          if (paymentMethods.payment_methods[i].id == paymentId) {
            paymentMethod = paymentMethods.payment_methods[i];
            break;
          }
        }
      }
    }
    return paymentMethod;
  };

  this._getDaysToFixPastDue = function (subscriptionName) {
    var subscription = this.presenter.models[subscriptionName];
    var maxDays = 8;
    var daysToFix = 0;
    if (subscription && subscription.status == 'past_due' && subscription.days_past_due !== null) {
      daysToFix = maxDays - subscription.days_past_due;
      if (daysToFix < 1) {
        daysToFix = 1;
      } else if (daysToFix > maxDays) {
        daysToFix = maxDays;
      }
    }
    return daysToFix;
  };

  this._determinePrecedence = function (subscription) {
    if (subscription.status == 'canceled' && subscription.end_date && new Date(subscription.end_date) < new Date()) {
      return this._subscriptionStatusPrecedence.canceled_expired;
    }
    return this._subscriptionStatusPrecedence[subscription.status];
  };

  this.init = function () {};

  this.initAllReady = function () {};

  this.destroy = function () {};
}